export default __webpack_public_path__ + "static/media/landscape-cursor.76072640.gif";